/**
 * Name filtering utilities
 */
/**
 * Apply country name filter to a list of countries
 */
export function applyCountryNameFilter(countries, filter, language) {
    if (!filter || typeof filter !== 'function') {
        return countries.map((c) => ({ ...c, _displayName: c.name }));
    }
    return countries
        .map((country) => {
        const filteredName = filter(country.iso_alpha_2, country.name, language, country);
        if (filteredName === false) {
            return null; // Skip this item
        }
        const displayName = filteredName !== null && filteredName !== undefined
            ? filteredName
            : country.name;
        return { ...country, _displayName: displayName };
    })
        .filter((c) => c !== null);
}
/**
 * Sort countries with Unicode-aware sorting
 */
export function sortCountries(countries, language) {
    const locale = language || undefined;
    return [...countries].sort((a, b) => {
        if (locale) {
            return a._displayName.localeCompare(b._displayName, locale, {
                sensitivity: 'accent', // Case-insensitive, accent-sensitive
                ignorePunctuation: false,
            });
        }
        return a._displayName.localeCompare(b._displayName);
    });
}
/**
 * Apply subdivision name filter to a list of subdivisions
 */
export function applySubdivisionNameFilter(subdivisions, filter, language, countryCode) {
    if (!filter || typeof filter !== 'function') {
        return subdivisions.map((s) => ({
            ...s,
            _displayName: s.full_name || s.name,
        }));
    }
    return subdivisions
        .map((subdivision) => {
        const originalName = subdivision.full_name || subdivision.name;
        const filteredName = filter(subdivision.code, originalName, language, countryCode, subdivision);
        if (filteredName === false) {
            return null; // Skip this item
        }
        const displayName = filteredName !== null && filteredName !== undefined
            ? filteredName
            : originalName;
        return { ...subdivision, _displayName: displayName };
    })
        .filter((s) => s !== null);
}
